import type { AxiosInstance } from "axios";

import { useQuery } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

interface Category {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	type: string;
	title: string;
	description: string;
	__type: string;
}
interface CategoryQueryResponse {
	data: Category[];
}
async function fetchCategories(axios: AxiosInstance) {
	const { data } = await axios.get<CategoryQueryResponse>("/category/all_subcategories");

	return data;
}
async function fetchCategory(axios: AxiosInstance, categoryId: string) {
	const data = await axios.get(`/category/view_category/${categoryId}`);
	return data.data.data;
}
export function useCategories() {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["categories"],
		queryFn: () => fetchCategories(privateAxios)
	});
}

export function useCategory(categoryId: string) {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["category", categoryId],
		queryFn: () => fetchCategory(privateAxios, categoryId)
	});
}
